import enUS from "./enUS.json";

// Register new locales here: add the import above and a key below.
const localeMap: Record<string, Record<string, string>> = {
  enUS
};

const DEFAULT_LOCALE = "enUS";

/**
 * Resolves a BE error reason code to a user-facing message.
 *
 * Lookup order:
 *   1. `locale` messages (if provided and key exists)
 *   2. `enUS` fallback (if the locale is missing the key)
 *   3. `undefined` (caller falls back to raw BE message)
 */
export const getErrorReasonMessage = (
  reason: string,
  locale: string = DEFAULT_LOCALE
): string | undefined => {
  const messages = localeMap[locale] ?? localeMap[DEFAULT_LOCALE];
  return messages[reason];
};
